import { Controller } from "@hotwired/stimulus"

const MODAL_LIST_SELECTOR = ".course-builder-add-case-modal__list"
const CASES_LIST_SELECTOR = ".course-builder-ds__cases-list"

export default class extends Controller {
  static targets = ["searchForm"]
  static values = {
    createUrl: String,
    destroyUrl: String,
    frameId: { type: String, default: "add_case_script_modal_frame" }
  }

  connect() {
    this.debounceTimer = null
  }

  disconnect() {
    if (this.debounceTimer) {
      clearTimeout(this.debounceTimer)
    }
  }

  debounceSearch() {
    if (this.debounceTimer) {
      clearTimeout(this.debounceTimer)
    }
    this.debounceTimer = setTimeout(() => this.submitSearch(), 300)
  }

  submitSearch() {
    if (!this.hasSearchFormTarget) {
      return
    }
    const pageInput = this.searchFormTarget.querySelector('input[name="page"]')
    if (pageInput) {
      pageInput.value = "1"
    }
    this.searchFormTarget.requestSubmit()
  }

  async toggle(event) {
    event.preventDefault()
    const button = event.currentTarget
    const documentId = event.params.documentId
    const inCourse = String(event.params.inCourse) === "true"
    if (!documentId) {
      return
    }

    button.disabled = true
    const scrollTops = this.captureListScrollTops()
    try {
      const url = inCourse ? this.destroyUrlValue : this.createUrlValue
      const method = inCourse ? "DELETE" : "POST"
      const response = await fetch(url, {
        method,
        headers: {
          Accept: "text/vnd.turbo-stream.html",
          "Content-Type": "application/json",
          "X-CSRF-Token": this.csrfToken
        },
        body: JSON.stringify({
          documentIds: [documentId],
          ...this.currentFilterParams()
        }),
        credentials: "same-origin"
      })

      if (!response.ok) {
        throw new Error("Request failed")
      }

      const html = await response.text()
      if (html && window.Turbo) {
        window.Turbo.renderStreamMessage(html)
      }
      this.restoreListScrollTops(scrollTops)
    } catch (_error) {
      button.disabled = false
    }
  }

  captureListScrollTops() {
    return {
      modalList: this.listScrollTop(MODAL_LIST_SELECTOR),
      casesList: this.listScrollTop(CASES_LIST_SELECTOR)
    }
  }

  restoreListScrollTops({ modalList, casesList }) {
    // Turbo replaces the list nodes; restore after the DOM swap settles.
    requestAnimationFrame(() => {
      this.setListScrollTop(MODAL_LIST_SELECTOR, modalList)
      this.setListScrollTop(CASES_LIST_SELECTOR, casesList)
    })
  }

  listScrollTop(selector) {
    const el = document.querySelector(selector)
    return el ? el.scrollTop : null
  }

  setListScrollTop(selector, value) {
    if (value == null) {
      return
    }
    const el = document.querySelector(selector)
    if (el) {
      el.scrollTop = value
    }
  }

  currentFilterParams() {
    if (!this.hasSearchFormTarget) {
      return {}
    }

    const data = new FormData(this.searchFormTarget)
    const params = {}
    data.forEach((value, key) => {
      if (value === "" || value == null) {
        return
      }
      if (Object.prototype.hasOwnProperty.call(params, key)) {
        params[key] = [].concat(params[key], value)
      } else {
        params[key] = value
      }
    })
    return params
  }

  get csrfToken() {
    return document.querySelector("meta[name='csrf-token']")?.content || ""
  }
}
